import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './BusinessMessage.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import { Link } from 'react-router-dom';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

const BusinessMessage = () => {

    useEffect(() => {
        document.title = `Business Message | Local Bells`;
        document.getElementById('bodywrap').className = 'busimessage';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Chat view toggle
    const [isChatOpen, setIsChatOpen] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };




    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible}/>
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <Row>
                                    <Col md={3} className={`msg-left ${isChatOpen ? 'd-none' : ''}`}>
                                        <div className='user-box'>
                                            <Link onClick={() => setIsChatOpen(true)}>
                                                <div className='user-box-single'>
                                                    <h6>Danielle Holland</h6>
                                                </div>
                                            </Link>
                                            <Link onClick={() => setIsChatOpen(true)}>
                                                <div className='user-box-single'>
                                                    <h6>William Middleton</h6>
                                                </div>
                                            </Link>
                                            <Link onClick={() => setIsChatOpen(true)}>
                                                <div className='user-box-single'>
                                                    <h6>Amit Sharma</h6>
                                                </div>
                                            </Link>
                                            <Link onClick={() => setIsChatOpen(true)}>
                                                <div className='user-box-single'>
                                                    <h6>Sebastian Knight</h6>
                                                </div>
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col md={9} className={`msg-right ${isChatOpen ? '' : 'd-none'}`}>
                                        <div className='msg-box'>
                                            <div className='msg-top'>
                                                <h6 className='fw-500 mb-0'>Amit Sharma</h6>
                                                <Link onClick={() => setIsChatOpen(false)}><h6 className='fw-500 mb-0 back-msg'>Back</h6></Link>
                                            </div>
                                            <div className='msg-bot'>
                                                <div className='msg-cont'>
                                                    <div className='left-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help? I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='right-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='left-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='right-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help? I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='left-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help? I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='left-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='right-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help? I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                    <div className='right-msg'>
                                                        <div>
                                                            <h6>I'm looking for personalized gifts, can you help?</h6>
                                                        </div>
                                                        <p>2 min</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Form className='msg-form'>
                                            <InputGroup className="anb-cont mb-3">
                                                <Form.Control
                                                    placeholder="Type message here"
                                                    aria-label="msg"
                                                    aria-describedby="msg"
                                                    type="text"
                                                />
                                                <InputGroup.Text id="msgbtn">
                                                    <Button variant="primary" type="submit" className='send-btn'>
                                                        <h6>Send</h6>
                                                    </Button>
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </Form>
                                    </Col>
                                </Row>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                   
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default BusinessMessage;


